require('./dist/manager').register();
